import React from "react";
import { FormattedMessage } from "react-intl";
var SYSTEM_USER_IDS = ["System", "System.Functions@pvhlink.com"];
export var UserName = React.memo(function (_a) {
    var userId = _a.userId, className = _a.className;
    if (!userId) {
        return React.createElement(FormattedMessage, { id: "username.unknown" });
    }
    if (SYSTEM_USER_IDS.includes(userId)) {
        return React.createElement(FormattedMessage, { id: "username.system" });
    }
    return React.createElement("span", { className: className }, userId);
});
UserName.displayName = 'UserName';
